import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
import AudioVisual from "vue-audio-visual";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHeart)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(AudioVisual);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  async created() {
    await this.$store.dispatch('init');
    console.log('initialized');
  }
}).$mount("#app");
